import { RAIL_STATE_IDS, VIDEO_LAYOUT_IDS, normalizeVideoLayoutId } from './layoutIds'

export const VIDEO_LAYOUT_OPTIONS = Object.freeze([
  Object.freeze({
    id: VIDEO_LAYOUT_IDS.stageOverlay,
    label: 'Stage Overlay',
    description: 'Full-bleed dominant frame with shared overlay controls and optional overlay rail',
  }),
  Object.freeze({
    id: VIDEO_LAYOUT_IDS.split,
    label: 'Split',
    description:
      'Solo for one participant, equal split for two, and split-led composition when more participants join',
  }),
  Object.freeze({
    id: VIDEO_LAYOUT_IDS.grid,
    label: 'Grid',
    description: 'Equal full-bleed tiles across the available video canvas',
  }),
])

export const RAIL_STATE_OPTIONS = Object.freeze([
  Object.freeze({
    id: RAIL_STATE_IDS.collapsed,
    label: 'Collapsed',
    description: 'Keep only the rail expand affordance visible',
  }),
  Object.freeze({
    id: RAIL_STATE_IDS.docked,
    label: 'Docked',
    description: 'Full-height rail on the right edge',
  }),
  Object.freeze({
    id: RAIL_STATE_IDS.stacked,
    label: 'Stacked',
    description: 'Bottom-right stack that grows only with visible cards',
  }),
  Object.freeze({
    id: RAIL_STATE_IDS.filmstrip,
    label: 'Filmstrip',
    description: 'Bottom-right horizontal strip with scroll controls',
  }),
])

const VIDEO_LAYOUT_DEFINITIONS = Object.freeze(
  VIDEO_LAYOUT_OPTIONS.reduce((definitions, option) => {
    definitions[option.id] = option
    return definitions
  }, {}),
)

export function listVideoLayouts() {
  return VIDEO_LAYOUT_OPTIONS
}

export function listRailStates() {
  return RAIL_STATE_OPTIONS
}

export function getVideoLayoutDefinition(layoutId) {
  const normalizedLayoutId = normalizeVideoLayoutId(layoutId)

  return (
    VIDEO_LAYOUT_DEFINITIONS[normalizedLayoutId] ||
    VIDEO_LAYOUT_DEFINITIONS[VIDEO_LAYOUT_IDS.stageOverlay]
  )
}
